"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = exports.NodeExpandCollapse = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var HierarchyTypeUtil_1 = require("../../HierarchyTypeUtil");
var GlobalStyle = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t.hierarchy-node-element {\n\t\tfont-size: ", ";\n\t\tpadding: ", " ", ";\n\t\tmargin: 2px;\n\t}\n\t.node-selected {\n\t\tcolor: ", ";\n\t\tbackground-color: #5f6263;\n\t}\n\t.leaf-node{\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tbackground-color: black;\n\t\tborder-radius: 50%;\n\t\tdisplay: inline-block;\n\t\tmargin-left: 6px;\n\t}\n\t.hierarchy-node {\n\t\tlist-style: none;\n\t}\t\n"], ["\n\t.hierarchy-node-element {\n\t\tfont-size: ", ";\n\t\tpadding: ", " ", ";\n\t\tmargin: 2px;\n\t}\n\t.node-selected {\n\t\tcolor: ", ";\n\t\tbackground-color: #5f6263;\n\t}\n\t.leaf-node{\n\t\theight: 10px;\n\t\twidth: 10px;\n\t\tbackground-color: black;\n\t\tborder-radius: 50%;\n\t\tdisplay: inline-block;\n\t\tmargin-left: 6px;\n\t}\n\t.hierarchy-node {\n\t\tlist-style: none;\n\t}\t\n"])), globalVars_module_scss_1.default.fontSizeBase, globalVars_module_scss_1.default.spacing5, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.white);
var HierarchyNode = styled_components_1.default.li.attrs({
    className: 'hierarchy-node',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tul {\n\t\tpadding-left: 20px;\n\t}\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"], ["\n\tul {\n\t\tpadding-left: 20px;\n\t}\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"])));
var NodeContainer = styled_components_1.default.div.attrs({
    className: 'node-container',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tbackground-color: #444;\n\tpadding: 10px 10px 10px 0;\n\tborder-radius: 2px;\n\tmargin-bottom: 5px;\n\tposition: relative;\n\t:hover {\n\t\tbackground-color: #0083a9 !important;\n\t}\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tbackground-color: #444;\n\tpadding: 10px 10px 10px 0;\n\tborder-radius: 2px;\n\tmargin-bottom: 5px;\n\tposition: relative;\n\t:hover {\n\t\tbackground-color: #0083a9 !important;\n\t}\n"])));
exports.NodeExpandCollapse = styled_components_1.default.div.attrs({
    className: 'node-expand-collapse',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tline-height: 1.1em;\n\twidth: 28px;\n\ttext-align: center;\n\tmargin-right: 10px;\n\t.toggle-node {\n\t\tfont-size: 12px;\n\t}\n\t&::after {\n\t\tcontent: ' ';\n\t\tborder-right: 1px solid #999;\n\t\tposition: absolute;\n\t\tleft: 28px;\n\t\theight: 100%;\n\t\ttop: 0;\n\t}\n"], ["\n\tline-height: 1.1em;\n\twidth: 28px;\n\ttext-align: center;\n\tmargin-right: 10px;\n\t.toggle-node {\n\t\tfont-size: 12px;\n\t}\n\t&::after {\n\t\tcontent: ' ';\n\t\tborder-right: 1px solid #999;\n\t\tposition: absolute;\n\t\tleft: 28px;\n\t\theight: 100%;\n\t\ttop: 0;\n\t}\n"])));
exports.NodeExpandCollapse.displayName = 'NodeExpandCollapse';
var NodeLabel = styled_components_1.default.div.attrs({
    className: 'node-label',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tcolor: #fff !important;\n\tcursor: pointer;\n\tposition: relative;\n\tborder: none;\n\tborder-radius: 2px;\n\twidth: 100%;\n\tline-height: 0.9em;\n\t.tws-input-checkbox-wrapper {\n\t\tmin-height: auto;\n\t\tline-height: 1em;\n\t\twidth: 100%;\n\t\t.tws-input-checkbox {\n\t\t\theight: auto;\n\t\t}\n\t\t.tws-input-checkbox-label {\n\t\t\tcolor: #fff !important;\n\t\t\tfont-size: 11px;\n\t\t\tpadding-left: 2px;\n\t\t\t&::before {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t\tbackground-size: 10px 10px;\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tcolor: #fff !important;\n\tcursor: pointer;\n\tposition: relative;\n\tborder: none;\n\tborder-radius: 2px;\n\twidth: 100%;\n\tline-height: 0.9em;\n\t.tws-input-checkbox-wrapper {\n\t\tmin-height: auto;\n\t\tline-height: 1em;\n\t\twidth: 100%;\n\t\t.tws-input-checkbox {\n\t\t\theight: auto;\n\t\t}\n\t\t.tws-input-checkbox-label {\n\t\t\tcolor: #fff !important;\n\t\t\tfont-size: 11px;\n\t\t\tpadding-left: 2px;\n\t\t\t&::before {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t\tborder: 0;\n\t\t\t}\n\t\t\t&::after {\n\t\t\t\theight: 14px;\n\t\t\t\twidth: 14px;\n\t\t\t\tbackground-size: 10px 10px;\n\t\t\t}\n\t\t}\n\t}\n"])));
NodeLabel.displayName = 'NodeLabel';
var Node = /** @class */ (function (_super) {
    __extends(Node, _super);
    function Node(props) {
        var _this = _super.call(this, props) || this;
        _this.handleExpandNode = _this.handleExpandNode.bind(_this);
        _this.checkNode = _this.checkNode.bind(_this);
        _this.getChecked = _this.getChecked.bind(_this);
        _this.getParentChecked = _this.getParentChecked.bind(_this);
        return _this;
    }
    Node.prototype.render = function () {
        var nodeConfig = this.initConfig();
        var nodeVm = this.props.nodes[this.props.nodeId];
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyle, null),
            React.createElement(HierarchyNode, { key: nodeVm.nodeId },
                React.createElement(NodeContainer, null,
                    React.createElement(exports.NodeExpandCollapse, null, !nodeConfig.isLeafNode && (React.createElement("a", { className: 'toggle-node', onClick: this.handleExpandNode },
                        React.createElement(aon_tws_common_ui_1.Icon, { name: nodeVm.isExpanded ? 'angle-up' : 'angle-down', style: { color: '#FFF' } })))),
                    React.createElement(NodeLabel, null, this.props.hideCheckbox ? (React.createElement("span", { className: 'tws-input-checkbox-wrapper' },
                        React.createElement("span", { className: 'tws-input-checkbox-label' }, this.getNodeLabel(nodeVm)))) : (React.createElement(aon_tws_common_ui_1.Checkbox, { label: this.getNodeLabel(nodeVm), checked: this.getChecked(), onChange: this.checkNode, disabled: this.props.parentChecked || this.props.selectAll || this.props.disabled })))),
                !nodeConfig.isLeafNode && nodeVm.isExpanded && React.createElement("ul", null,
                    " ",
                    this.getChildNodes(nodeVm),
                    " "))));
    };
    Node.prototype.getChecked = function () {
        var nodeSelected = !!(this.props.selectionCriteria.descendantsIncluded[this.props.nodeId] || this.props.selectionCriteria.singleIncluded[this.props.nodeId]);
        return nodeSelected || this.props.selectAll || this.props.parentChecked;
    };
    Node.prototype.getParentChecked = function () {
        return !!this.props.selectionCriteria.descendantsIncluded[this.props.nodeId];
    };
    Node.prototype.checkNode = function () {
        var nodeVm = this.props.nodes[this.props.nodeId];
        this.props.onChangeSelectNode(this.props.nodeId, this.getHierarchyTypeUtil().getNodeDisplayName({ nodeVm: nodeVm, fullName: true }));
    };
    Node.prototype.initConfig = function () {
        if (this.props.nodes && this.props.nodes[this.props.nodeId]) {
            var nodeVm = this.props.nodes[this.props.nodeId];
            return {
                isLeafNode: this.getHierarchyTypeUtil().isLeafNode(nodeVm),
                isOpenNode: !nodeVm.nodeData,
                isTopNode: this.props.isTopNode,
            };
        }
        return undefined;
    };
    Node.prototype.getNodeLabel = function (nodeVm) {
        var displayName = this.getHierarchyTypeUtil().getNodeDisplayName({ nodeVm: nodeVm, fullName: true });
        // Append additional information to the display name if showOwners is true.
        if (this.props.showOwners === true) {
            var owners = nodeVm.ownerNames !== undefined && nodeVm.ownerNames !== null ? nodeVm.ownerNames.join(', ') : '';
            // Only add the access annotation if there are actually owners.
            if (owners.length > 1) {
                return displayName + ' (access: ' + owners + ')';
            }
        }
        return displayName;
    };
    Node.prototype.getHierarchyTypeUtil = function () {
        return HierarchyTypeUtil_1.HierarchyTypeUtilFactory.getHierarchyTypeUtil(this.props.hierarchyHeader.hierarchyType);
    };
    Node.prototype.getChildNodes = function (nodeVm) {
        var _this = this;
        var childNodes = [];
        if (nodeVm.isExpanded) {
            childNodes = childNodes.concat(nodeVm.childrenIds.map(function (childNodeId) {
                if (_this.props.nodes && childNodeId !== nodeVm.nodeId && _this.props.nodes[childNodeId]) {
                    var childPosition = _this.props.nodes[childNodeId];
                    return (React.createElement(Node, __assign({}, _this.props, { key: childPosition.nodeId, nodeId: childPosition.nodeId, isTopNode: false, level: _this.props.level + 1, parentChecked: _this.props.parentChecked || _this.getParentChecked() })));
                }
                return undefined;
            }));
        }
        return childNodes;
    };
    Node.prototype.handleExpandNode = function (e) {
        var nodeVm = this.props.nodes[this.props.nodeId];
        e.preventDefault();
        this.props.toggleNode(nodeVm.nodeId, nodeVm.isExpanded);
    };
    return Node;
}(React.Component));
exports.Node = Node;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
